var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27832",
    "data-name": "Grupo 27832",
    transform: "translate(-1500.149 -522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25521",
    "data-name": "Grupo 25521",
    transform: "translate(343 219)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2215",
    "data-name": "Elipse 2215",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1157.149 303)",
    fill: "#e5f4f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25545",
    "data-name": "Grupo 25545",
    transform: "translate(583.36 343.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69340",
    "data-name": "Trazado 69340",
    d: "M933.975,193.359a3.725,3.725,0,1,0-3.725-3.725A3.725,3.725,0,0,0,933.975,193.359Zm0-6.209a2.483,2.483,0,1,1-2.483,2.483A2.484,2.484,0,0,1,933.975,187.15Z",
    transform: "translate(-2.187)",
    fill: "#0099b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69341",
    "data-name": "Trazado 69341",
    d: "M931.789,204.8a5.594,5.594,0,0,0-5.588,5.588.621.621,0,1,0,1.242,0,4.346,4.346,0,0,1,8.692,0,.621.621,0,1,0,1.241,0A5.594,5.594,0,0,0,931.789,204.8Z",
    transform: "translate(0 -10.204)",
    fill: "#0099b7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPerfil);
export default __webpack_public_path__ + "static/media/Icono-Perfil.f3af2137ad47c62c8a8eba59bb352c3d.svg";
export { ForwardRef as ReactComponent };